import React from 'react';
import { Empty, Spin } from 'antd';
import './LoadingEmpty.less';

const LoadingEmpty = React.memo(({ loading }) => (
  <>{loading ? <Spin className="layout" size="large" delay={0} spinning={loading} /> : <Empty className="layout" image={Empty.PRESENTED_IMAGE_SIMPLE} />}</>
));

export default LoadingEmpty;
